import { Link } from "react-router-dom";
import SectionLink from "@/components/SectionLink";

export default function Footer() {
  return (
    <footer className="w-full bg-secondary-900 text-background-100 px-6 md:px-10 lg:px-14 pt-20 pb-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <img
                src={`${import.meta.env.BASE_URL}logo.png`}
                alt="Meridian Coffee Roasters"
                className="h-10 w-10 object-contain brightness-0 invert"
              />
              <span className="font-heading text-2xl text-background-50">Meridian</span>
            </div>
            <p className="text-sm text-background-200 leading-relaxed">
              Small-batch coffee roasters based on SE Division in Portland, Oregon. Roasting since first light, 2011.
            </p>
          </div>

          <div>
            <h4 className="font-heading text-lg text-background-50 mb-5">Wander</h4>
            <ul className="space-y-3 text-sm">
              <li><SectionLink hash="#home" className="text-background-200 hover:text-accent-300 cursor-pointer">Home</SectionLink></li>
              <li><SectionLink hash="#about" className="text-background-200 hover:text-accent-300 cursor-pointer">About</SectionLink></li>
              <li><SectionLink hash="#coffee" className="text-background-200 hover:text-accent-300 cursor-pointer">Coffee</SectionLink></li>
              <li><SectionLink hash="#visit" className="text-background-200 hover:text-accent-300 cursor-pointer">Visit</SectionLink></li>
              <li><SectionLink hash="#editorial" className="text-background-200 hover:text-accent-300 cursor-pointer">Editorial</SectionLink></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-lg text-background-50 mb-5">Roastery</h4>
            <ul className="space-y-3 text-sm text-background-200">
              <li>1420 SE Division St</li>
              <li>Portland, OR 97202</li>
              <li>
                <a href="tel:+15550102030" className="hover:text-accent-300 cursor-pointer">
                  (555) 010-2030
                </a>
              </li>
              <li>
                <a href="mailto:hello@meridiancoffee.example" className="hover:text-accent-300 cursor-pointer">
                  hello@meridiancoffee.example
                </a>
              </li>
              <li className="pt-2">
                {/* The office, not the cafe — the shop's trading hours live in
                    the Visit section and are longer than these. */}
                <span className="block text-xs uppercase tracking-widest text-background-300 mb-1">
                  Office hours
                </span>
                Open Monday to Friday, 9 to 5.
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-lg text-background-50 mb-5">Follow along</h4>
            <p className="text-sm text-background-200 mb-5">
              Slow letters. New roasts, journal notes, and quiet updates from the workshop.
            </p>
            <div className="flex items-center gap-3">
              <a
                href="#"
                aria-label="Instagram"
                className="w-10 h-10 flex items-center justify-center rounded-full border border-background-100/20 hover:bg-accent-500 hover:border-accent-500 hover:text-primary-950 transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line w-5 h-5 flex items-center justify-center"></i>
              </a>
              <a
                href="#"
                aria-label="Substack"
                className="w-10 h-10 flex items-center justify-center rounded-full border border-background-100/20 hover:bg-accent-500 hover:border-accent-500 hover:text-primary-950 transition-colors cursor-pointer"
              >
                <i className="ri-newspaper-line w-5 h-5 flex items-center justify-center"></i>
              </a>
              <a
                href="#"
                aria-label="Pinterest"
                className="w-10 h-10 flex items-center justify-center rounded-full border border-background-100/20 hover:bg-accent-500 hover:border-accent-500 hover:text-primary-950 transition-colors cursor-pointer"
              >
                <i className="ri-pinterest-line w-5 h-5 flex items-center justify-center"></i>
              </a>
              <a
                href="#"
                aria-label="Spotify"
                className="w-10 h-10 flex items-center justify-center rounded-full border border-background-100/20 hover:bg-accent-500 hover:border-accent-500 hover:text-primary-950 transition-colors cursor-pointer"
              >
                <i className="ri-spotify-line w-5 h-5 flex items-center justify-center"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-background-100/15 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-300">
            © 2026 Meridian Coffee Roasters. Roasted with care in Portland since 2011.
          </p>
          <div className="flex items-center gap-6 text-xs text-background-300">
            <a href="#" className="hover:text-accent-300 cursor-pointer">Privacy</a>
            <a href="#" className="hover:text-accent-300 cursor-pointer">Terms</a>
            <Link to="/wholesale" className="hover:text-accent-300 cursor-pointer">Wholesale</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}